<section class="sbnb-onboarding">
  <sbnb-user-header [back]="'/user/hello'"></sbnb-user-header>

  <article class="main">
    <h2 class="nomargin">Create your new password</h2>
    <p style="margin-top: 0">Go ahead and enter your new password below.</p>

    <label>{{ 'CORE.PASSWORD' | transloco }}</label>
    <mat-form-field class="fw">
      <input type="password" matInput placeholder="Min 8 characters" [(ngModel)]="newPassword" />
    </mat-form-field>

    <label>{{ 'CORE.PASSWORD' | transloco }} check</label>
    <mat-form-field class="fw">
      <input type="password" matInput placeholder="Type it again" [(ngModel)]="newPassword2" />
    </mat-form-field>

    <button
      class="fw"
      [disabled]="loading || !this.newPassword || !this.newPassword2"
      type="submit"
      mat-flat-button
      (click)="setPasswordClicked()">
      <mat-spinner *ngIf="loading" class="button__spinner" [diameter]="30"></mat-spinner>
      <span>Continue</span>
    </button>
  </article>

  <aside>
    <div style="height: 563px; display: flex; align-items: flex-end; justify-content: center">
      <img src="/assets/images/signup/password.svg" />
    </div>
  </aside>
</section>
